import { render, staticRenderFns } from "./salmonthcounttable.vue?vue&type=template&id=301433d0&scoped=true&"
import script from "./salmonthcounttable.vue?vue&type=script&lang=js&"
export * from "./salmonthcounttable.vue?vue&type=script&lang=js&"
import style0 from "./salmonthcounttable.vue?vue&type=style&index=0&id=301433d0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "301433d0",
  null
  
)

export default component.exports